export default [

    {
        path: '/MaintenanceHomePage',
        name: 'MaintenanceHomePage',
        component: () => import('../../views/Maintenance/MaintenanceHomePage.vue'),
        meta: {
            keepAlive: true
        }
    },
    {
        path: '/MaintenancePublishHome',
        name: 'MaintenancePublishHome',
        component: () => import('../../views/Maintenance/MaintenancePublishHome.vue'),
        meta: {
            keepAlive: true
        }
    },
    {
        path: '/MaintenancePublishingNode', // 维保发布
        name: 'MaintenancePublishingNode',
        component: () => import('../../views/Maintenance/CirculationNodes/MaintenancePublishingNode.vue'),

    },
    {
        path: '/MaintenanceAuditNode', // 维保审核
        name: 'MaintenanceAuditNode',
        component: () => import('../../views/Maintenance/CirculationNodes/MaintenanceAuditNode.vue'),

    },
    {
        path: '/MaintenanceIssuingNode', //维保签发
        name: 'MaintenanceIssuingNode',
        component: () => import('../../views/Maintenance/CirculationNodes/MaintenanceIssuingNode.vue'),

    },
    {
        path: '/draftMaintenanceHome',
        name: 'draftMaintenanceHome',
        component: () => import('../../views/Maintenance/Maintenancedraft/draftMaintenanceHome.vue'),
        meta: {
            keepAlive: true
        }
    },
    {
        path: '/MaintenancereadonlyHome',
        name: 'MaintenancereadonlyHome',
        component: () => import('../../views/Maintenance/Maintenancereadonly/MaintenancereadonlyHome.vue'),
        meta: {
            keepAlive: true
        }
    },
    {
        path: '/maintenanceHistoryPage',
        name: 'MaintenanceHistoryPage',
        component: () => import('../../views/Maintenance/historyPage/maintenanceHistoryPage.vue'),
    },
    { //文件下载
        path: '/MaintenanceFileDownload',
        name: 'MaintenanceFileDownload',
        component: () => import('../../views/Maintenance/Documents/MaintenanceFileDownload.vue'),
    },
    { //文件生成
        path: '/MaintenanceGenerateDocument',
        name: 'MaintenanceGenerateDocument',
        component: () => import('../../views/Maintenance/Documents/MaintenanceGenerateDocument.vue'),
    }

]